// extracted by css-extract-rspack-plugin
export default {"container":"EjzEHxI___container","icon":"YUOs_9M___icon"};